module.exports = __webpack_public_path__ + "static/media/infoIcon.dc4a23a6.png";